module.exports = __webpack_public_path__ + "static/media/icon_send.69986b46.svg";